import { GOALS, STAGE_GOALS, stageGoalReward } from "./goals.js";
import { HANGAR, nextCost } from "./hangar.js";

// 試合が終わったときの精算: DOPA を足し、記録を更新し、目標の達成を調べ、次の目標を選ぶ。
// save を書き換えて、結果の画面に出す中身を返す(保存は呼ぶ側)。

// スコアから DOPA へ(5分クリアで 400 前後)
export const DOPA_PER_SCORE = 1 / 100;
// 記録の [save.records のキー, run のキー]。更新したものは run のキー(画面では record.<キー> の文)で返す
const RECORD_KEYS = [
  ["bestProgress", "progress"],
  ["bestScore", "score"],
  ["bestKills", "kills"],
  ["bestCombo", "combo"],
  ["bestLevel", "level"],
];

export function settleRun(save, run) {
  const rec = save.records;
  const before = { ...rec };
  // earned: もらった DOPA の内訳。kind は score・clear・goal・stageGoal(goal・stageGoal のときは goal も)。文にするのは画面の側(src/meta/screens.js)
  // 先の面ほど DOPA の倍率が高い(run.dopaMul。config.missions の dopa)
  const mul = run.dopaMul || 1;
  const earned = [{ kind: "score", mul, amount: Math.floor(run.score * DOPA_PER_SCORE * mul) }];
  if (run.clear) earned.push({ kind: "clear", mul, amount: Math.round(100 * mul) });
  // 面のクリア: 初めてなら次の面のカードが増える
  const firstClear = run.clear && run.mission && !save.cleared[run.mission];
  if (run.clear && run.mission) save.cleared[run.mission] = (save.cleared[run.mission] || 0) + 1;

  const newRecords = [];
  for (const [key, from] of RECORD_KEYS) {
    if (run[from] > rec[key]) {
      if (rec[key] > 0) newRecords.push(from); // 初めての試合は「更新」と言わない
      rec[key] = run[from];
    }
  }
  rec.clears += run.clear ? 1 : 0;
  rec.totalKills += run.kills;

  const achieved = [];
  for (const g of GOALS) {
    if (save.goals[g.id] || !g.check(run, save)) continue;
    save.goals[g.id] = true;
    achieved.push(g);
    earned.push({ kind: "goal", goal: g, amount: g.reward });
  }
  // 面ごとの目標(その面で初めてのものだけ DOPA。stageGoals は結果の画面に出す3つの状態)
  const stageAchieved = [];
  let stageGoals = null;
  if (run.mission) {
    const done = save.stageGoals[run.mission] || {};
    for (const g of STAGE_GOALS) {
      if (done[g.id] || !g.check(run, save)) continue;
      done[g.id] = true;
      stageAchieved.push(g);
      earned.push({ kind: "stageGoal", goal: g, mul, amount: stageGoalReward(g, mul) });
    }
    if (stageAchieved.length) save.stageGoals[run.mission] = done;
    stageGoals = STAGE_GOALS.map((g) => ({ goal: g, done: !!done[g.id], now: stageAchieved.includes(g), reward: stageGoalReward(g, mul) }));
  }
  const total = earned.reduce((a, e) => a + e.amount, 0);
  save.dopa += total;
  save.totalDopa += total;

  return { earned, total, newRecords, achieved, stageAchieved, stageGoals, before, firstClear, mission: run.mission, next: nextGoals(save, run), shop: nextShopHint(save) };
}

// まだの目標を、近い順に n 個
export function nextGoals(save, run, n = 3) {
  return GOALS.filter((g) => !save.goals[g.id])
    .map((g) => ({ goal: g, near: Math.min(0.99, Math.max(0, g.progress(run, save))) }))
    .sort((a, b) => b.near - a.near)
    .slice(0, n);
}

// 格納庫でいちばん安い次の強化と、買えるか・あといくらか
export function nextShopHint(save) {
  let best = null;
  for (const id of Object.keys(HANGAR)) {
    const cost = nextCost(save, id);
    if (cost != null && (!best || cost < best.cost)) best = { id, cost };
  }
  if (!best) return null;
  return { ...best, affordable: save.dopa >= best.cost, short: Math.max(0, best.cost - save.dopa) };
}
